"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = media;
var _systemConstants = require("@telus-uds/system-constants");
function media() {
  return {
    query: {},
    from(breakpoint) {
      if (breakpoint !== _systemConstants.viewports.xs) {
        this.query.minWidth = breakpoint;
      }
      return this;
    },
    until(breakpoint) {
      this.query.maxWidth = breakpoint;
      return this;
    },
    and(custom) {
      this.query.and = custom;
      return this;
    },
    css(style) {
      const {
        minWidth,
        maxWidth,
        and
      } = this.query;
      const min = minWidth ? `(min-width: ${_systemConstants.viewports.map.get(minWidth)}px)` : undefined;
      const max = maxWidth ? `(max-width: ${_systemConstants.viewports.map.get(maxWidth) - 1}px)` : undefined;
      if (typeof min !== 'undefined' || typeof max !== 'undefined' || typeof and !== 'undefined') {
        const mediaQuery = `@media ${[min, max, and].filter(a => a).join(' and ')}`;
        this.query = {};
        return {
          [mediaQuery]: {
            ...(typeof style === 'function' ? style() : style)
          }
        };
      }
      return typeof style === 'function' ? style() : style;
    }
  };
}